<template lang="">
  <div class="bbs_filter">
    <div class="lft_area">
      <div class="bbs_info">
        <div class="total"><strong>{{ getCurrentCount() }}</strong> / {{ categoryListCount }}</div>
      </div>
    </div>
    <div class="rgt_area">
      <div class="bbs_srch">
        <select name="" id="" class="i_sel" v-model="searchType">
          <option
            v-for="option in searchOptions"
            :value="option.value"
          >{{ option.name }}</option>
        </select>
        <input type="text" class="i_txt" name="keyword" v-model="searchWord">
        <button type="button" class="bt_base gray btn_srch" @click="getSearch">검색</button>
      </div>
    </div>
  </div>

  <div class="bbs_list">
    <table class="bbs_tbl">
      <colgroup>
        <col style="width:90px">
        <col style="width:30px">
        <col style="width:auto">
        <col style="width:auto">
        <col style="width:100px">
      </colgroup>
      <thead>
        <tr>
          <th scope="col">
            <span class="ui_chkbox primary nontxt">
              <input 
                type="checkbox"
                @change="toggleAllCheck($event.target.checked)"
              >
              <label for=""></label>
            </span>
          </th>
          <th scope="col">번호</th>
          <th scope="col">카테고리 명</th>
          <th scope="col">부모 카테고리</th>
          <th scope="col">사용여부</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(category, index) in categoryList"
        >
          <td>
            <span class="ui_chkbox primary nontxt">
              <input 
                type="checkbox"
                :value="category.categorySeq"
                v-model="selectedCategories"
              >
              <label for=""></label>
            </span>
          </td>
          <td>{{ index + 1 }}</td>
          <td class="category"><a href="#none">{{ category.name }}</a></td>
          <td class="category">{{ category.categoryParent }}</td>
          <td>
            <select 
              class="i_sel" 
              style="width:88px"
              @change="changeUseYn(category)"
              v-model="category.useYn"
            >
              <option value="Y">사용</option>
              <option value="N">미사용</option>
            </select>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <div class="paginate">
    <AdminPagination
      :totalPages = "totalPages()"
      :currentPage = "currentPage"
      @changePage = "changePage"
    />

    <div class="rgt_area">
      <button type="button" class="bt_base primary large_h" @click="createCategory">카테고리 등록</button>
      <button type="button" class="bt_base gray large_h" @click="deleteSelectedCategories">삭제</button>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import AdminPagination from '@/components/common/AdminPagination.vue';

const adminCategoryModule = 'adminCategoryModule'

export default {
  components: {
    AdminPagination
  },

  data () {
    return {
      currentPage: 1,
      selectedCategories: [],

      searchOptions: [
        { name: '전체', value: 'none' },
        { name: '공지사항', value: '공지사항' },
        { name: 'FAQ', value: 'FAQ' },
      ],
      searchType: '',
      searchWord: ''
    }
  },
  methods: {
    ...mapActions(adminCategoryModule, [
      'requestCategoryList',
      'requestDeleteCategories',
      'requestChangeCategoryUseYn'
    ]),

    createCategory () {
      this.$router.push({ name: "CategoryManageCreatePage" })
    },

    totalPages() {
      return Math.ceil(this.categoryListCount / 10);
    },

    async changePage(page) {
      this.currentPage = page
      const {currentPage, searchType, searchWord} = this
      await this.requestCategoryList({currentPage, searchType, searchWord})
    },

    getCurrentCount() {
      const currentFirstCount = (this.currentPage - 1) * 10 + 1
      let currentLastCount = this.currentPage * 10
      if (parseInt(currentLastCount) > parseInt(this.categoryListCount)) {
        currentLastCount = this.categoryListCount
      }
      return currentFirstCount + '-' + currentLastCount
    },

    toggleAllCheck(isChecked) {
      if (isChecked) {
        this.selectedCategories = []
        for (const category of this.categoryList) {
          this.selectedCategories.push(category.categorySeq)
        }
      } else {
        this.selectedCategories = []
      }
    },

    async deleteSelectedCategories() {
      if (this.selectedCategories.length === 0) {
        alert('선택된 카테고리가 없습니다');
        return;
      }

      const { searchType, searchWord, currentPage } = this;
      const fetchCategories = async (page = 1, type = searchType, word = searchWord, isReset = false) => {
        const params = { currentPage: page, searchType: type, searchWord: word };
        await this.requestCategoryList(params);
        if (isReset) {
          this.searchType = 'none';
        }
      };

      await this.requestDeleteCategories(this.selectedCategories);
      this.selectedCategories = [];

      await fetchCategories(currentPage);

      if (this.categoryList.length === 0 && this.currentPage > 1) {
        this.currentPage -= 1;
        await fetchCategories(this.currentPage);
      }

      if (this.categoryList.length === 0 || this.currentPage === 1) {
        this.currentPage = 1;
        this.searchType = '';
        this.searchWord = '';
        await fetchCategories(1, '', '', true);
      }
    },

    changeUseYn(category) {
      this.requestChangeCategoryUseYn(category.categorySeq)
    },

    async getSearch() {
      if (this.searchWord === '') {
        alert('검색어를 입력해주세요')
        return
      }
      this.currentPage = 1
      const {currentPage, searchType, searchWord} = this
      await this.requestCategoryList({currentPage, searchType, searchWord})
    }
  },

  computed: {
    ...mapState(adminCategoryModule, [
      'categoryList',
      'categoryListCount'
    ])
  },

  async mounted() {
    const {currentPage, searchType, searchWord} = this
    await this.requestCategoryList({currentPage, searchType, searchWord})
    this.searchType = 'none'
  }
}
</script>
<style lang="">
    
</style>